import { Component, ContentChild, Input, OnInit } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { LocalizationHelperService } from '../../shared/localization/localization-helper.service';

class LangOption {
  locale: string;
  name: string;
}

const COMPONENT_SELECTOR = 'wlm-language-selector';

@Component({
    selector: COMPONENT_SELECTOR,
    templateUrl: './language-selector.component.html',
    styleUrls: ['./language-selector.component.scss'],
    standalone: false
})
export class LanguageSelectorComponent implements OnInit {
  @ContentChild(MatMenu) matMenu: MatMenu;

  private _translateScope: string;
  get translateScope(): string {
    return this._translateScope;
  }
  @Input() set translateScope(value: string) {
    this._translateScope = value;
    this.configTranslation();
  }

  langs: LangOption[] = [];
  currentLocale: string;

  constructor(private _localization: LocalizationHelperService) {}

  ngOnInit(): void {}

  /**
   * Configures translation-related data and build the array of available languages.
   */
  configTranslation(): void {
    this.currentLocale = this._localization.currentLocale;
    this._localization.get(`${this.translateScope}.language-options`).subscribe((ts) => {
      const locales = this._localization.getLocales();
      this.langs = locales.map((locale) => ({ locale, name: ts[locale] }));
    });
  }

  /**
   * Set the selected locale to the active one.
   * @param locale The selected locale.
   */
  setLocale(locale: string) {
    this._localization.useLocale(locale);
  }
}
